import { ComponentElem } from "@components/interfaces";
import PopupBase from "./PopupBase";
import RadioSelect from "../ui/checkboxs/RadioSelect";
import { ReserveState } from "../reserve-state/ReserveStateTypes";
import ApiProxy from "@root/ts/ApiProxy";
import CheckboxSmall from "../ui/checkboxs/CheckboxSmall";
import Popups from "./Popups";
import schema from "@schema/common/cancel-order.json"
import { MemberOrder } from "../member-order/MemberOrder";

export default class CancelQuestionnaire extends PopupBase {
  static instance: CancelQuestionnaire;

  _radioSelect: RadioSelect;
  _orderSN: string;
  $btnConfirm: JQuery;

  constructor(elem: ComponentElem) {
    super(elem);
    this.$btnConfirm = this.$root.find(".btn-confirm");
    let pageData: ReserveState.PageData | MemberOrder.PageData = ApiProxy.getPageData();
    if (!pageData.cancel_questionnaire_options)
      return;
    let $radioSelect = this.$root.find(".radios");
    let $sample = $($radioSelect.find(".radio")[0]).clone();

    $radioSelect.empty();

    pageData.cancel_questionnaire_options.forEach((data) => {
      let $elem = $sample.clone();
      $elem.attr("data-value", data.id);
      $elem.attr("data-text", data.text);
      $elem.find(".text").text(data.text);
      $radioSelect.append($elem);
      new CheckboxSmall($elem[0] as ComponentElem);
    });

    this._radioSelect = new RadioSelect($radioSelect[0] as ComponentElem);
    this._radioSelect.emitter.on("change", () => {
      let values: string[] = this._radioSelect.getValue() as string[];
      (values.length === 0) ? this.$btnConfirm.attr("disabled", "true") : this.$btnConfirm.removeAttr("disabled");
    });
    CancelQuestionnaire.instance = this;
  }

  reset() {
    this._radioSelect.reset();
  }

  getFormData() {
    let valueArray: string[] = this._radioSelect.getValue() as string[];
    let textArray: string[] = this._radioSelect.getText() as string[];
    let array: any[] = [];

    valueArray.forEach((value, index) => {
      array.push({ id: valueArray[index], text: textArray[index] });
    });

    let formData = { "questionnaire": array };
    return formData.questionnaire.length > 0 ? formData : null;
  }

  open(orderSN: string) {
    this._orderSN = orderSN;
    this.reset();
    return new Promise((resolve) => {
      Popups.to("cancel-questionnaire");
      this.$btnConfirm.off().on("click", (event: JQuery.ClickEvent) => {
        event.preventDefault();
        let formData: any = this.getFormData();
        if (formData) {
          formData.order_sn = this._orderSN;
          console.log(formData);
          ApiProxy.quickCall("common/cancel-order", formData, undefined, { schema: schema }).then(() => {
            Popups.close();
            resolve(true);
          })
        }
      });
    });
  }
}